export enum EventName {
  ActivityVideoLoadingTimeout = 'ActivityVideoLoadingTimeout',
  AccessAccountDialogAlreadyConsumedPurchase = 'AccessAccountDialogAlreadyConsumedPurchase',
  AccessAccountDialogAlreadyCreatedUser = 'AccessAccountDialogAlreadyCreatedUser',
  AddToVocabulary = 'AddToVocabulary',
  AppInstalled = 'AppInstalled',
  AuthFlow = 'AuthFlow',
  ChangeNumberDialogAlreadyCreatedUser = 'ChangeNumberDialogAlreadyCreatedUser',
  ChangeOnboardingCarousel = 'ChangeOnboardingCarousel',
  ClickToOpenPaywall = 'ClickToOpenPaywall',
  ClosePaywall = 'ClosePaywall',
  CloseDialogPurchaseAlreadyConsumed = 'CloseDialogPurchaseAlreadyConsumed',
  ClosedDialogAlreadyConsumedPurchase = 'ClosedDialogAlreadyConsumedPurchase',
  CloseDialogWhatsAppNotValidated = 'CloseDialogWhatsAppNotValidated',
  ShowDialogConfirmPurchaseAlreadyConsumed = 'ShowDialogConfirmPurchaseAlreadyConsumed',
  ConfirmDialogWhatsAppNotValidated = 'ConfirmDialogWhatsAppNotValidated',
  ConsumePurchase = 'ConsumePurchase',
  ConversationDisconnect = 'ConversationDisconnect',
  CopyRemainInviteURL = 'CopyRemainInviteURL',
  ErrorAlertCompletePurchase = 'ErrorAlertCompletePurchase',
  ErrorAlertUpdatePurchaseBySource = 'ErrorAlertUpdatePurchaseBySource',
  PurchaseAlreadyConsumed = 'PurchaseAlreadyConsumed',
  DialogPurchaseNotFound = 'DialogPurchaseNotFound',
  ErrorOnSignInAfterCompletePurchase = 'ErrorOnSignInAfterCompletePurchase',
  ErrorPurchaseInvalid = 'ErrorPurchaseInvalid',
  AssessmentOpenHomeLoader = 'AssessmentOpenHomeLoader',
  AssessmentOpenReview = 'AssessmentOpenReview',
  GetPurchaseByEmail = 'GetPurchaseByEmail',
  HomeOpenStreakCalendar = 'HomeOpenStreakCalendar',
  InitiateCheckout = 'InitiateCheckout',
  MediaRecorderNotSupported = 'MediaRecorderNotSupported',
  MediaRecorderSupported = 'MediaRecorderSupported',
  OnboardingFlow = 'OnboardingFlow',
  OnboardingFormBack = 'OnboardingFormBack',
  OnboardingFormNextStep = 'OnboardingFormNextStep',
  OnboardingFormOpenSupport = 'OnboardingFormOpenSupport',
  OnboardingTokenRecognized = 'OnboardingTokenRecognized',
  OpenAccount = 'OpenAccount',
  OpenAppAfterFinished = 'OpenAppAfterFinished',
  OpenBeConfidentOnWhatsAppAfterFinished = 'OpenBeConfidentOnWhatsAppAfterFinished',
  OpenBeConfidentOnWhatsAppAfterFinishedAppDisabled = 'OpenBeConfidentOnWhatsAppAfterFinishedAppDisabled',
  OpenInvitePage = 'OpenInvitePage',
  OpenInterests = 'OpenInterests',
  OpenPaywall = 'OpenPaywall',
  OpenPolicyPrivacy = 'OpenPolicyPrivacy',
  OpenPurchases = 'OpenPurchases',
  OpenReminderSettings = 'OpenReminderSettings',
  OpenReferralSettings = 'OpenReferralSettings',
  OpenSupport = 'OpenSupport',
  OpenSupportAppDisabled = 'OpenSupportAppDisabled',
  OpenTermsAndConditions = 'OpenTermsAndConditions',
  SelectVoiceToConversation = 'SelectVoiceToConversation',
  OpenVoices = 'OpenVoices',
  OpenWhatsApp = 'OpenWhatsApp',
  OpenDownloadApp = 'OpenDownloadApp',
  PageView = 'pageView',
  ProfileError = 'ProfileError',
  ProfileOpenPlacementTest = 'ProfileOpenPlacementTest',
  ProfileOpenCertificates = 'ProfileOpenCertificates',
  ProfileOpenSettings = 'ProfileOpenSettings',
  Purchase = 'Purchase',
  PurchaseVerified = 'PurchaseVerified',
  PurchaseFound = 'PurchaseFound',
  PurchaseIdIsNull = 'PurchaseIdIsNull',
  PurchaseNotFoundAndUserNotFound = 'PurchaseNotFoundAndUserNotFound',
  RealTimeClickTranslateMessage = 'RealTimeClickTranslateMessage',
  NotFoundPage = 'NotFoundPage',
  RedirectToBuyOnExternalCheckout = 'RedirectToBuyOnExternalCheckout',
  RedirectToBuyPurchaseNotFound = 'RedirectToBuyPurchaseNotFound',
  RemoveFromVocabulary = 'RemoveFromVocabulary',
  ResendWhatsAppVerificationCode = 'ResendWhatsAppVerificationCode',
  ResentWhatsAppVerificationCode = 'ResentWhatsAppVerificationCode',
  RestorePurchase = 'RestorePurchase',
  ReviewOpenAssessment = 'ReviewOpenAssessment',
  SendAuthOTP = 'SendAuthOTP',
  SendOnboardingOTP = 'SendOnboardingOTP',
  ShowDialogPurchaseAlreadyConsumed = 'ShowDialogPurchaseAlreadyConsumed',
  ShowDialogAlreadyConsumedPurchase = 'ShowDialogAlreadyConsumedPurchase',
  ShowDialogAlreadyCreatedUser = 'ShowDialogAlreadyCreatedUser',
  ShowDialogAppDisabled = 'ShowDialogAppDisabled',
  ShowDialogWhatsAppNotValidated = 'ShowDialogWhatsAppNotValidated',
  SignIn = 'SignIn',
  SignOut = 'SignOut',
  SuccessInAppPurchase = 'SuccessInAppPurchase',
  ValidatePurchase = 'ValidatePurchase',
  ValidateWhatsApp = 'ValidateWhatsApp',
  ValidatingWhatsAppVerificationCode = 'ValidatingWhatsAppVerificationCode',
  WaitlistApp = 'WaitlistApp',
  OpenPreActivityHome = 'OpenPreActivityHome',
  OpenMicrophonePermissionModal = 'OpenMicrophonePermissionModal',
  ClosePreActivityHome = 'ClosePreActivityHome',
  ShowBeTooltip = 'ShowBeTooltip',
  HideBeTooltip = 'HideBeTooltip',
  AskForFinishActivity = 'AskForFinishActivity',
  SkipActivityOutputInteraction = 'SkipActivityOutputInteraction',
  ActivityConsolidatedAssessmentIsReady = 'ActivityConsolidatedAssessmentIsReady',
  OnSessionInteractionInput = 'OnSessionInteractionInput',
  CloseActivity = 'CloseActivity',

  // Session
  ReportBugSession = 'ReportBugSession',

  // Welcome
  WelcomeOpen = 'WelcomeOpen',
  WelcomeGoToAccessAccount = 'WelcomeGoToAccessAccount',
  WelcomeGoToOnboarding = 'WelcomeGoToOnboarding',

  // Onboarding
  CloseOnboardingProductDiscovery = 'CloseOnboardingProductDiscovery',
  CloseOnboardingSocialProof = 'CloseOnboardingSocialProof',

  // Likert
  LikertOpen = 'LikertOpen',
  LikertSubmit = 'LikertSubmit',

  // Fullscreen loader
  FullscreenLoaderBackToHomeButton = 'FullscreenLoaderBackToHomeButton',

  // Assessment Review
  OpenAssessmentReview = 'OpenAssessmentReview',
  CloseAssessmentReviewWithoutCompletion = 'CloseAssessmentReviewWithoutCompletion',
  PlayCorrectGrammarAssessment = 'playCorrectGrammarAssessment',
  PlayCorrectPronunciationAssessment = 'playCorrectPronunciationAssessment',
  ReviewAttempt = 'ReviewAttempt',
  SkipReviewAttempt = 'SkipReviewAttempt',
  OpenAssessmentReviewConversationHistory = 'OpenAssessmentReviewConversationHistory',
}
